import { EmptyState, PageHeader } from "@auradata/ui";
import { createFileRoute } from "@tanstack/react-router";
import { projectNav } from "@/features/shell/nav";

/** Placeholder for project screens that arrive in step 4 (Runs, Jobs, Tests…). */
export const Route = createFileRoute("/w/$workspace/p/$project/$")({
  component: ProjectSectionPlaceholder,
});

function ProjectSectionPlaceholder() {
  const { _splat } = Route.useParams();
  const [section, ...rest] = (_splat ?? "").split("/");
  const item = projectNav.find((n) => n.id === section);
  const title = item?.label ?? section ?? "Screen";
  return (
    <>
      <PageHeader
        title={title}
        meta={rest.length ? <span className="font-mono">{rest.join("/")}</span> : undefined}
      />
      <EmptyState
        title={`${title} is next`}
        description="This screen is built in step 4. The shell, scope and data flow are already wired."
      />
    </>
  );
}
